module.exports = __webpack_public_path__ + "static/media/csv.6c9fe356.svg";